<app-close testId="shell-admin-menu-close" />

<app-title tag="h2" tagStyle="h4" [title]="'auth.admin.title' | translate" />

<nav [attr.aria-label]="'admin-menu.aria-label' | translate">
    <ul role="list">
        @for (item of items; track $index) {
            <li>
                <app-item [item]="item" />
            </li>
        }
    </ul>
</nav>
